import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description ShieldPlus icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { ShieldPlus } from '@sravni/design-system-icons'
 *
 * <ShieldPlus />
 * ```
 */
var ShieldPlus = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "ShieldPlus", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.666 9.318c0 3.784-2.844 7.323-6.666 8.182-3.823-.86-6.667-4.398-6.667-8.182V6.346c0-.677.41-1.287 1.036-1.543l4.167-1.705a3.864 3.864 0 0 1 2.928 0l4.166 1.705a1.667 1.667 0 0 1 1.036 1.543v2.972ZM13 10h-3m0 0H7m3 0V7m0 3v3", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { ShieldPlus };
//# sourceMappingURL=ShieldPlus.js.map
